<template>
    <div class="container">
        <h1 class="title">
            Users
        </h1>
        <p class="subtitle">
            GW2 Scratch API key management
        </p>
        <b-message v-if="error" type="is-danger" has-icon>
            {{error}}
        </b-message>
        <b-tabs>
            <b-tab-item label="Add new user">
                <div class="columns">
                    <div class="column is-one-third">
                        <b-field label="API key">
                            <b-input v-model="newKey" />
                        </b-field>
                        <b-field label="Comment">
                            <b-input v-model="newComment" />
                        </b-field>
                        <b-field label="Permissions">
                            <b-taginput v-model="newPermissions" :data="permissions"
                                        :allow-new="false" :allow-duplicates="false" autocomplete :open-on-focus="true"
                                        placeholder="Add permissions"
                            />
                        </b-field>
                        <b-button @click="addNewUser()">
                            Add new user
                        </b-button>
                    </div>
                </div>
            </b-tab-item>

            <b-tab-item label="User list">
                <b-table
                        :data="users"
                        :loading="loading"
                        striped
                        narrowed
                        :default-sort="['comment', 'Comment']"
                >
                    <template slot-scope="props">
                        <b-table-column field="key" label="API Key" sortable>
                            {{ props.row.key }}
                        </b-table-column>
                        <b-table-column field="comment" label="Comment" sortable>
                            {{ props.row.comment }}
                        </b-table-column>
                        <b-table-column field="permissions" label="Permissions" sortable>
                            <b-taglist>
                                <b-tag v-bind:key="index" v-for="(permission, index) in props.row.permissions">
                                    {{ permission }}
                                </b-tag>
                            </b-taglist>
                        </b-table-column>
                        <b-table-column label="Actions">
                            <b-button @click="deleteKey(props.row)">Delete</b-button>
                        </b-table-column>
                    </template>
                </b-table>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
    import axios from 'axios'
    import uuidv4 from 'uuid/v4'

    export default {
        name: 'user-list',
        components: {
        },
        data() {
            return {
                users: [],
                permissions: [],
                loading: false,
                newKey: uuidv4(),
                newComment: "",
                newPermissions: [],
            }
        },
        methods: {
            loadAsyncData() {
                this.buyType = this.$route.params.buy;
                this.loading = true;
                let getUsers = axios.get("/users/").then(response =>
                {
                    this.users = response.data;
                }).catch(error => {
                    this.users = [];
                    this.error = error;
                });

                let getPermissions = axios.get("/users/permissions").then(response =>
                {
                    this.permissions = response.data;
                }).catch(error => {
                    this.permissions = [];
                    this.error = error;
                });

                Promise.all([getUsers, getPermissions]).then(() => this.loading = false);
            },
            deleteKey(user) {
                let data = new FormData();
                data.set("key", user.key);

                axios.post("/users/delete", data
                ).then(() =>
                {
                }).catch(error => {
                    this.error = error;
                }).then(() => {
                    this.loadAsyncData();
                });
            },
            addNewUser() {
                let data = new FormData();
                data.set("key", this.newKey);
                data.set("comment", this.newComment);
                data.set("permissions", this.newPermissions.join(","));

                axios.post("/users/add", data
                ).then(() =>
                {
                }).catch(error => {
                    this.error = error;
                }).then(() => {
                    this.loadAsyncData();
                });
            }
        },
        mounted() {
            this.loadAsyncData();
        }
    }
</script>
